
window.addEventListener('DOMContentLoaded', function() {
  /* --------------- fade in anime --------------- */	
  const fadeinElements = document.querySelectorAll('.fade-in');
  const scroll = window.scrollY;
  const windowHeight = window.innerHeight;

  fadeinElements.forEach(function(element) {
    const elemPos = element.getBoundingClientRect().top + scroll;
    if (scroll > elemPos - windowHeight + 50) {
			setTimeout(function() {
      	element.classList.add('scrollin');
			}, 500);
    }
  });
	
});

